export default __webpack_public_path__ + "static/media/uottahack8logo.feacf840.png";